import React, { Component } from 'react';
import ReactHighcharts from 'react-highcharts';
import FullenChart from 'highcharts/modules/funnel';
import TileChart from 'highcharts/modules/tilemap';
import HeatMap from 'highcharts/modules/heatmap';
import ChartHOC from './ChartHOC'
import { chartDownloadFileName, normalizeHighchartsConfig } from '../../utils/chartTheme';
import { DownloadPngButton } from './pngExport';

class Charts extends Component {
    constructor(props) {
        super(props);
        this.nodeRef = React.createRef();
        FullenChart(ReactHighcharts.Highcharts)
        TileChart(ReactHighcharts.Highcharts)
        HeatMap(ReactHighcharts.Highcharts)
    }
    componentWillMount() {
        // console.log(this.props)
    }
    render() {
        return (
            <div ref={this.nodeRef} className='relative'>
                {!this.props.disableDownload && (
                    <div className='absolute right-1 top-1 z-10' data-download-ignore='true'>
                        <DownloadPngButton
                            nodeRef={this.nodeRef}
                            fileName={this.props.downloadName || chartDownloadFileName(this.props.config?.title?.text)}
                        />
                    </div>
                )}
                <ReactHighcharts config={normalizeHighchartsConfig(this.props.config)} ref="chart"></ReactHighcharts>
            </div>
        )
    }
}
export default ChartHOC(Charts);
